import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as WmsTooltip } from 'react-tooltip';
import { NO_CHARGES_POSTED, isInvoiceableTask } from '../../../utils/taskInvoice';

// Admin task list "Invoice" action; greyed out for tasks that are never invoiced (Wallet Recharge).
const TaskInvoiceListingAction = ({ item, onClick }) => {
    const anchorId = `taskInvoice-${item.id}`;
    const enabled = isInvoiceableTask(item);

    return (
        <>
            {/* Tooltip anchors on the wrapper because disabled buttons swallow hover events. */}
            <span id={anchorId} className="d-inline-block">
                <button
                    type="button"
                    className={`iconBtnListing mr-15 ${enabled ? 'cursorPointer' : ''}`}
                    disabled={!enabled}
                    onClick={onClick}
                    aria-label={enabled ? 'Invoices' : NO_CHARGES_POSTED}
                    style={enabled ? undefined : { opacity: 0.4, pointerEvents: 'none' }}
                >
                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                </button>
            </span>
            <WmsTooltip
                anchorId={anchorId}
                content={enabled ? 'Invoices' : NO_CHARGES_POSTED}
                place="left"
                className="tooltipWidth"
            />
        </>
    );
};

TaskInvoiceListingAction.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        taskTypeName: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default TaskInvoiceListingAction;
